'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _Legend = require('./Legend');

var _Legend2 = _interopRequireDefault(_Legend);

var _Column = require('./Column');

var _Column2 = _interopRequireDefault(_Column);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MinimumEducation(_ref) {
  var title = _ref.title,
      moduleClass = _ref.moduleClass,
      addClass = _ref.addClass,
      legend = _ref.legend,
      columns = _ref.columns;

  return _react2.default.createElement(
    'div',
    {
      className: 'tab-content type-minimum_education ' + moduleClass + ' ' + addClass
    },
    _react2.default.createElement(
      'h4',
      null,
      title
    ),
    _react2.default.createElement(
      'div',
      { className: 'columns three-columns' },
      columns.map(function (_ref2, key) {
        var title = _ref2.title,
            image = _ref2.image,
            data = _ref2.data;
        return _react2.default.createElement(_Column2.default, {
          key: key,
          title: title,
          image: image,
          data: data
        });
      })
    ),
    _react2.default.createElement(_Legend2.default, {
      legend: legend
    })
  );
} /*
    {
      "type": "minimum_education",
      "tab": "Minimum Education Required"
      "legend": [
        {
          "id": "associate",
          "label": "Up to Associate Degree",
        },
        {
          "id": "bachelor",
          "label": "Up to Bachelor Degree",
        },
      ],
      "columns": [
        {
          "title": "Banking",
          "image": {
            "url": "http://placeimg.com/300/300/animals",
            "title": "Photo Title",
            "alt": "Photo alt"
          },
          "data": [
            {
              "value": 0.8,
              "legend": "associate",
            },
            {
              "value": 0.6,
              "legend": "bachelor",
            }
          ],
  
        }
      ]
    }
  
  */

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps, _selectors.mapDispatchToProps)(MinimumEducation);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/MinimumEducation/MinimumEducation.jsx
// module id = 1245
// module chunks = 0